const getErrorTranslation = (error: string) => {
  if (error === 'Credit card number entered is not valid') {
    return 'El número de tarjeta introducido no es válido';
  }
  if (error === 'La tarjeta no es Cencosud Scotiabank') {
    return 'La tarjeta no es Cencosud Scotiabank';
  }
  return 'El número de tarjeta introducido no es válido';
};

export const CardNumberInput = ({
  error,
  numberElementId
}: {
  error: spreedly.SpreedlyError['message'];
  numberElementId: string;
}) => {
  return (
    <div className="co-flex co-w-full co-flex-col co-gap-[8px]">
      <CardNumberLabel htmlFor={numberElementId} />
      <div className="co-flex co-flex-col co-gap-[4px]">
        <div className="co-w-full co-h-[48px]" id={numberElementId}></div>
        <InputError error={error} />
      </div>
    </div>
  );
};

const CardNumberLabel = ({ htmlFor }: { htmlFor: string }) => {
  return (
    <label
      className="co-flex co-w-fit co-text-[12px] co-font-semibold co-leading-[16px] co-text-[#363F45]"
      htmlFor={htmlFor}
    >
      Número de tarjeta
    </label>
  );
};

const InputError = ({
  error
}: {
  error: spreedly.SpreedlyError['message'];
}) => {
  if (!error) return <></>;

  const translatedError = getErrorTranslation(error);

  return (
    <p
      className="co-px-[8px] co-text-[12px] co-leading-[16px] co-font-medium co-text-[#E90200]"
      id="number-error"
    >
      {translatedError}
    </p>
  );
};
